export const locale = {
    lang: 'es',
    data: {
        'NAV': {
            'APPLICATIONS': 'Menú',
            'TABLERO': 'Inicio',
            'RUTERO': 'Gestión comercial',
            'CONSULTA_EXISTENCIAS': 'Consulta de existencias',
            'CONSULTA': 'Consulta',
            'INDICADORES': 'Indicadores',
            'RESUMEN_GESTION': 'Resumen de gestión',
            'LOGOUT': 'Salir',
            'CONFIGURACION': 'Configuración',
            'TIPO_NOTA_CREDITO': 'Tipos de nota crédito',
            'CAUSAL': 'Causales',
            'SUBCAUSAL': 'Subcausales',
            'CAUSANTE': 'Causantes',
            'ORDEN_RECOLECCION_NC': 'Orden de recolección nota crédito',
            'ORDEN_RECOLECCION_GARANTIA': 'Orden de recolección garantía',
            'CONSULTA_PEDIDOS' : 'Consulta de pedidos',
            'AUTORIZACIONES':'Autorizaciones',
            'HISTORICO_AUTORIZACION':'Historico autorización',
            'PEDIDOS_ESCALADOS':'Pedidos escalados',
            'VENTAS_PERDIDAS':'Ventas perdidas',
            'GESTION_AUTORIZADOR':'Gestion autorizador',
            'GESTION_ADMINISTRADOR':'Gestion administrador',
            'PDF': 'Promociones',
            'MODIFICAR_PDF': 'Carga catalogo promociones',
            'CARGA_PROMOCIONES':'Carga promociones',
            'PEDIDOS_SIN_BANDEJA':'Pedidos Sin Autorizar'
        },
        'NAV2': {
            'PROMOCIONES': 'Buscar promociones',
            'RESTABLECER': 'Borrar promociones',
            'ADICIONAR': 'Adicionar obsequio o descuento',
            'SUGERIDO_1': 'Sugerir pedido',
            'SUGERIDO_2': 'Sugerir pedido 2',
            'SUGERIDO_3': 'Sugerir pedido 3',
            'DESCUENTO': 'Descuento financiero',
            'REMISION': 'Gestionar Remisiones',
            'PDF': 'Catalogo Promociones',
        }
    }
};